import { Trans } from '@lingui/react'
import { shape } from 'prop-types'
import { PureComponent } from 'react'
import { connectStateResults } from 'react-instantsearch-dom'

import './FilterBox.scss'

class FilterBox extends PureComponent {
  render() {
    const { nbHits: total } = this.props.searchResults || {}

    return (
      <div className="e-FilterBox u-position--relative">
        <ul className="l-flex l-flex--wrap a-list-reset">
          <li>
            <span
              className="u-font-weight--bold u-color--grey e-FilterBox__title"
              data-qa-id="search-result-result-counter"
              suppressHydrationWarning
            >
              <Trans
                id="searchResults.label.totalResultsNumber"
                values={{ total }}
              />
            </span>
          </li>
        </ul>
      </div>
    )
  }
}

FilterBox.propTypes = {
  searchResults: shape({}),
}

FilterBox.defaultProps = {
  searchResults: null,
}

export default connectStateResults(FilterBox)
